<template>
    <div v-if="isVisible" class="modal-overlay">
        <DDialog :modelValue="isVisible" @update:modelValue="updateVisibility">
            <DCard >
                <DCardSection  class="title">
                    <h5>{{ title }}</h5>
                </DCardSection>
                <DCardSection class="message">
                    <p>{{ message }}</p>
                </DCardSection>
                <DCardSection align="right">
                    <DButton @click="cancel" color="primary" label="Cancel" />
                    <DButton @click="confirm" color="negative" label="Yes, delete it!" />
                </DCardSection>
            </DCard>
        </DDialog>
    </div>
</template>

<script>
import DButton from '@components/ui/DButton.vue'
import DDialog from '@components/ui/DDialog.vue'
import DCard from '@components/ui/DCard.vue'
import DCardSection from '@components/ui/DCardSection.vue'
export default {
    components: {
        DButton,
        DDialog,
        DCard,
        DCardSection
    },
    props: ['isVisible', 'title', 'message'],
    methods: {
        confirm() {
            this.$emit('confirm')
        },
        cancel() {
            this.$emit('cancel')
        },
        updateVisibility(value) {
      this.$emit('update:isVisible', value)
    }
    }
}
</script>

<style>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal-window {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    color: black;
}

.btn {
    color: white;
    border: none;
    padding: 8px 16px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 5px;
}

.btn-blue {
    background-color: #0077B6;
}

.btn-red {
    background-color: #FF0000;
}

.buttons {
    display: flex;
    justify-content: flex-end;
}
.title{
    font-size: 20px;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.0125em;
    color: black;
}
.message{
    font-size: 14px;
    font-weight: 100;
    line-height: 2rem;
    letter-spacing: 0.0125em;
    color: black;
}
h5{
    margin: 0px;
    text-align: left;
}
</style>
